import type { ReactNode } from 'react';

export type ActionColor =
  'blue' | 'green' | 'red' | 'orange' | 'cyan' | 'purple' | 'teal' | 'default';

const ACTION_COLORS: Record<ActionColor, string> = {
  blue: 'bg-accent/10 text-accent hover:bg-accent/20',
  green: 'bg-success/10 text-success hover:bg-success/20',
  red: 'bg-danger/10 text-danger hover:bg-danger/20',
  orange: 'bg-warning/10 text-warning hover:bg-warning/20',
  cyan: 'bg-action-cyan/10 text-action-cyan hover:bg-action-cyan/20',
  purple: 'bg-action-purple/10 text-action-purple hover:bg-action-purple/20',
  teal: 'bg-action-teal/10 text-action-teal hover:bg-action-teal/20',
  default: 'bg-panel-hover text-ink hover:bg-panel-hover-strong',
};

interface ActionButtonProps {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  color?: ActionColor;
  /** Lý do nút bị tắt — nút mờ mà không nói vì sao thì người dùng chỉ biết bấm mãi. */
  title?: string;
}

/** Nút thao tác trên thẻ tài khoản — mỗi việc một màu để nhận ra không cần đọc chữ. */
export function ActionButton({
  children,
  onClick,
  disabled,
  color = 'default',
  title,
}: ActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`flex h-full w-full items-center justify-center gap-1.5 rounded-lg px-3 py-1.5 text-[10px] font-bold transition-all duration-150 disabled:cursor-not-allowed disabled:opacity-50 ${ACTION_COLORS[color]}`}
    >
      {children}
    </button>
  );
}
